export class MidOfficeDiagnose {
    modId: string;
    modCode: string;
    modType: string;
    modIsActive: boolean;
    modComment: string;
    icdDiagnoses = [];
}